<div class="inm-carousel" [style]="gridVars()">
  <div
    class="inm-carousel__track"
    [class.inm-carousel__track--variable]="effectiveVariableWidth()"
    #track
  >
    @if (itemTemplate()) {
      @for (item of dataSource(); track trackBy($index, item)) {
        <div
          class="inm-carousel__item"
          [class.inm-carousel__item--active]="activeIndex() === $index"
        >
          <ng-container
            *ngTemplateOutlet="itemTemplate(); context: { $implicit: item, index: $index, animate: animationState() }"
          />
        </div>
      }
    }
  </div>

  <ng-content select="[inmCarouselPrev]"></ng-content>
  <ng-content select="[inmCarouselNext]"></ng-content>
  <ng-content select="[inmCarouselPoint]"></ng-content>
</div>
